import { render, staticRenderFns } from "./serviceStation.vue?vue&type=template&id=72c44e9a&"
import script from "./serviceStation.vue?vue&type=script&lang=js&"
export * from "./serviceStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports